import api from './api';
import type { TenantNotification } from '@/mocks/notifications';

function unwrapNotificationList(value: unknown): TenantNotification[] {
  if (Array.isArray(value)) return value as TenantNotification[];
  if (value && typeof value === 'object') {
    const data = (value as { data?: unknown }).data;
    if (Array.isArray(data)) return data as TenantNotification[];
  }
  return [];
}

function unwrapUnreadCount(value: unknown): { count: number } {
  const payload =
    value && typeof value === 'object' && 'data' in value
      ? (value as { data?: unknown }).data
      : value;

  if (payload && typeof payload === 'object') {
    const raw = (payload as { count?: unknown; unread_count?: unknown }).count
      ?? (payload as { unread_count?: unknown }).unread_count;
    const count = Number(raw ?? 0);
    return { count: Number.isFinite(count) ? count : 0 };
  }

  const count = Number(payload ?? 0);
  return { count: Number.isFinite(count) ? count : 0 };
}

export const notificationService = {
  list: () => api.get<unknown>('/notify').then((r) => unwrapNotificationList(r.data)),
  unreadCount: () =>
    api.get<unknown>('/notify/unread-count').then((r) => unwrapUnreadCount(r.data)),
  markRead: (id: string) =>
    api.patch<{ ok: true }>(`/notify/${id}/read`).then((r) => r.data),
  markAllRead: () => api.patch<{ ok: true }>('/notify/read-all').then((r) => r.data),
};
